import { ref, computed } from 'vue';
import { useOrderStore } from '@/stores/order';
import { STATUS_PROCESSING } from '@/constants/order';

/**
 * useCheckoutState composable
 * Centralizes checkout eligibility and modal state logic for reuse across components.
 * Usage:
 *   const { canCheckout, openCheckoutModal, setOpenCheckoutModal } = useCheckoutState();
 */
export function useCheckoutState() {
  const orderStore = useOrderStore();
  const openCheckoutModal = ref(false);

  // Computed property for checkout eligibility
  const canCheckout = computed(() => {
    // You can adjust this logic as needed
    return orderStore.totalItems > 0 && orderStore.orderStatus !== STATUS_PROCESSING;
  });

  // Function to toggle modal state
  function setOpenCheckoutModal(value) {
    openCheckoutModal.value = value;
  }

  return {
    canCheckout,
    openCheckoutModal,
    setOpenCheckoutModal,
  };
}
